export type NoteProperty = {
    timestamp: Date | null;
    noteBody: string | null;
    hubspotOwnerId: number;
}

export const defaultNoteProperty: NoteProperty = {timestamp: null, noteBody: "", hubspotOwnerId: 0}; 